import { useQuery } from "react-query";
import { getEntities } from "../../services/scientific/entity";
import { PagedRequestType } from "../../types/PagedResults";
import { ENTITIES, Key_entities } from "../../utils/constants";


export const useGetEntitiesQuery = (data: PagedRequestType) =>
  useQuery(
    [Key_entities, JSON.stringify(data)],
    () => getEntities(data)
  );
